import React from 'react';
import {Button} from 'reactstrap';
import {AvForm} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import DepartmentColumn from "../../shared/component/dataTable/columns/DepartmentColumn.json";
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import DepartmentService from "../../shared/service/DepartmentService";
import '../../shared/styles/SettingsPage.css';

export default class DepartmentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            departmentList: []
        }
        this.departmentService = new DepartmentService();
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.departmentService.findAll().then(response => this.setState({
            departmentList: response
        }));
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Departments</h1>
                        </div>

                        <div className="settings-page__panel">
                            {GeneralUtils.checkPrivilege("post_product/department") &&
                                <div className="settings-page__toolbar settings-page__toolbar--start">
                                    <Button
                                        color="outline-primary"
                                        className="settings-page__btn--add"
                                        onClick={() => {
                                            window.location.href = "#departmentSave?";
                                        }}>
                                        <i className="pi pi-plus" aria-hidden="true"/>
                                        <Translate contentKey="entity.action.add">Add</Translate>
                                    </Button>
                                </div>}

                            {GeneralUtils.checkPrivilege("get_product/department") &&
                                <div className="settings-page__table-wrap settings-page__table-wrap--department">
                                    <DataTableWithButton
                                        ref={(elem) => this.refDataTable = elem}
                                        fields={DepartmentColumn.fields}
                                        objectName={DepartmentColumn.name}
                                        data={this.state.departmentList}
                                        paginator={true}
                                        rows={10}
                                        selectionMode="single"
                                        onDataSelect={this.onDataSelect}
                                        loading={this.state.loading}/>
                                </div>}
                        </div>
                    </div>
                </AvForm>
            </div>
        );
    }

    onDataSelect = (data) => {
        window.location.href = "#departmentSave?" + data.id;
    }
}
